// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.c-carousel[data-v-52165e62] {\n  width: 100%;\n}\n.c-carousel[data-v-52165e62] .v-carousel__controls {\n  visibility: hidden;\n}\n.c-carousel[data-v-52165e62]:hover .v-carousel__controls {\n  visibility: visible;\n}\n.c-item[data-v-52165e62] {\n  position: relative;\n  padding: 0px;\n  margin: 0px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
